export const doNothing = (): void => {};

export const doNothingAsync = async (): Promise<void> => Promise.resolve();

export const delay = async (ms: number): Promise<unknown> => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
};

export function randomIntFromInterval(min: number, max: number): number {
  return (window.crypto.getRandomValues(new Uint32Array(1))[0] % (max - min + 1)) + min;
}
